import React, { Fragment } from 'react';
import { TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL } from 'Tracking/events/events.trackings';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { LayerActivities } from 'Components/widgets/layer-activities/LayerActivities';
import { ProductActivitiesCategories } from 'Components/widgets/product-activities-categories/ProductActivitiesCategories';
import { ProductActivitiesThematics } from 'Components/widgets/product/product-activities-thematics/ProductActivitiesThematics';
import { Rentals } from 'Components/widgets/rentals/Rentals';
import { RentalsCta } from 'Components/widgets/rentals-cta/RentalsCta';
import { asWidgetProps } from 'Src/types/cast-helpers';
import type { ComponentProps } from 'react';
export const ProductActivitiesLine = ({ id, resort }: ProductActivitiesLineProps) => {
  const trackingData = { ...TRACK_CLICK_EVENT_UPSELL_RENTALS_DETAIL, categoryGA: 'shopping' };
  const trackF = useTracking();

  const track = () => trackF(trackingData);

  if (!resort) {
    return null;
  }

  const categories = resort.activityTree || [];
  const thematics = resort.thematicActivityTree || [];
  return (
    <SiteContainer className="Line" id={id}>
      <ProductActivitiesCategories
        className="my-40"
        categories={categories}
        productName={resort?.name}
      />
      {!!thematics?.length && (
        <ProductActivitiesThematics
          className="my-40"
          hasRentals={resort.rentalsTree.length > 0}
          thematics={thematics}
          trackRentals={track}
        />
      )}
      <LayerActivities categories={categories} thematics={thematics} />
      {!!resort.rentalsTree.length && (
        <Fragment>
          <div className="-m-10 justify-end md:flex">
            <div className="px-10 md:w-2/3">
              {resort?.thematicActivityTree?.length === 0 && (
                <RentalsCta className="h-310" onClick={track} />
              )}
            </div>
          </div>
          <Rentals
            {...asWidgetProps<ComponentProps<typeof Rentals>>({
              onClick: track,
              rentalsTree: resort.rentalsTree,
            })}
          />
        </Fragment>
      )}
    </SiteContainer>
  );
};
